export default __webpack_public_path__ + "static/media/markEmailUnreadGreen.8b2d2744.svg";